module.exports = __webpack_public_path__ + "static/media/excedentes2.429ffd78.svg";